import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogueHandler, CreateUserDialogueHandler } from '../types';
import CreateUserContext from './CreateUserContext';

const { ConfirmationDialogue } = vp;

type CreateUserDialogueProps = {
  handleDialogue: DialogueHandler<CreateUserDialogueHandler>;
};

type FC = FunctionComponent<CreateUserDialogueProps>;

const CreateUserDialogue: FC = ({ handleDialogue }: CreateUserDialogueProps) => {
  const { showCreateUserSuccessAlert, showCreateUserErrorAlert, CreateUserError } = useContext(CreateUserContext);
  const { t } = useTranslation('translations', { keyPrefix: 'Users.CreateUser.CreateUserDialogue' });

  return useMemo(
    () => (
      <div>
        {/* Create User Error */}
        <ConfirmationDialogue
          isVisible={showCreateUserErrorAlert}
          title={t('error.title')}
          status="error"
          subTitle={t('error.subTitle', { CreateUserError })}
          confirm={{
            label: t('error.button'),
            action: () => handleDialogue({ type: 'create', state: 'fail' }),
          }}
        />
        {/* Create User Success */}
        <ConfirmationDialogue
          isVisible={showCreateUserSuccessAlert}
          title={t('success.title')}
          status="success"
          subTitle={t('success.subTitle')}
          confirm={{
            label: t('success.button'),
            action: () => handleDialogue({ type: 'create', state: 'success' }),
          }}
        />
      </div>
    ),
    [showCreateUserSuccessAlert, showCreateUserErrorAlert],
  );
};

export default CreateUserDialogue;
